import { render, staticRenderFns } from "./ProjectsTabs.vue?vue&type=template&id=2e41047e&scoped=true"
import script from "./ProjectsTabs.vue?vue&type=script&lang=js"
export * from "./ProjectsTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTabs.vue?vue&type=style&index=0&id=2e41047e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41047e",
  null
  
)

export default component.exports